import { useGetProductQuery } from '.codegen/generatedApi'
import GridContainer from '@feature/GridContainer'
import GridItem from '@feature/GridItem'
import ImageGallery from '@feature/ImageGallery'
import LoadingPopover from '@feature/LoadingPopover/LoadingPopover'
import ProductDataTable from '@feature/ProductDataTable'
import RelatedProducts from '@feature/RelatedProducts'
import Space from '@feature/Space'
import Stockists from '@feature/Stockists'
import TermWebsiteLink from '@feature/TermWebsiteLink'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import { selectProductBySlug } from 'app/results/resultsSlice'
import { getSelectTermsById } from 'app/selectors'
import useHtml from 'helpers/useHtml'
import React from 'react'
import { RouteComponentProps } from 'react-router'

type ProductSingleProps = RouteComponentProps<{
  slug: string
}>

const ProductSingle = (props: ProductSingleProps) => {
  const { match } = props
  const slug = match.params.slug

  const { isLoading } = useGetProductQuery({ slug })

  const product = useAppSelector(selectProductBySlug(slug))
  const showLoading = isLoading
  const [brandTerm] = useAppSelector(getSelectTermsById('BRAND', product ? product.brands.map((t) => t.id) : []))
  const contentHtml = useHtml(product?.content || '')

  const { id, title, packSize, stockists, brand, mainCategory, images } = product ?? {}

  return (
    <>
      {showLoading && <LoadingPopover />}

      <GridContainer justifyContent={'space-between'} paddingY={3} rowGap={4}>
        <GridItem xs={12} sm={6} md={6}>
          {/* Image Gallery */}
          <ImageGallery images={images} sticker={product?.sticker} stickerImage={product?.stickerImage} />
        </GridItem>
        <GridItem xs={12} sm={6} md={5}>
          <Stack component="header" spacing={1} mb={4}>
            <Typography variant="h1">{title}</Typography>
            <Typography variant="subtitle1" component="a" href={brandTerm?.website} target="_blank" color="GrayText">
              {brandTerm?.name || brand}
            </Typography>
            <Typography variant="bold">{packSize}</Typography>
          </Stack>

          <Box mb={4}>{contentHtml}</Box>

          {/* Similar Brand Products */}
          {brandTerm && id && (
            <RelatedProducts productId={id} term={brandTerm} marginTop={2} marginBottom={4} hideTitle hideCta justifyContent={'initial'} GridItemProps={{ xs: 4, md: 3 }} ProductProps={{ hideBrand: true }} />
          )}

          <TermWebsiteLink term={brandTerm ? { websiteLabel: 'View Brand Website', ...brandTerm } : null} sx={{ mb: {xs: 6, md: 12} }} />
          {/* Data Table */}
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          {/* Stockists */}
          <Stockists termsBases={stockists} termIds={brandTerm?.brandStockistIds} />
        </GridItem>
        <GridItem xs={12} sm={6} md={5}>
          <ProductDataTable product={product} />
        </GridItem>
        {/* <GridItem xs={12} sm={6} md={5}></GridItem> */}
      </GridContainer>

      <Space y="xl" />

      <Divider />

      <Space y="xl" />

      {/* Related Products */}
      {mainCategory && id ? <RelatedProducts productId={id} term={mainCategory} marginY={5} GridItemProps={{ md: 3 }} /> : null}
    </>
  )
}

export default ProductSingle
